module.exports = __webpack_public_path__ + "img/back_arrow.531bb354.svg";